function readEnv(key: string): string | undefined {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const v = (import.meta as any)?.env?.[key]
    return typeof v === 'string' && v.length > 0 ? v : undefined
  } catch {
    return undefined
  }
}

function resolveAuthBaseUrl(): string {
  const raw = readEnv('VITE_AUTH_BASE_URL')
  if (raw) return raw.replace(/\/+$/, '')
  // Same origin — gateway proxies /auth/* to the auth service.
  return ''
}

export const AUTH_BASE_URL = resolveAuthBaseUrl()

export function authUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${AUTH_BASE_URL}${p}`
}
